/**
 * Structured step outputs of the current copilot run, keyed by step id.
 *
 * The platform publishes a `step_output` event for workflow steps that opt
 * in (`config.publishOutput: true`), carrying the step's structured output —
 * for the Client Backends copilot, the code writer's whole endpoint
 * definition. Keeping it here lets a world method take the definition by
 * reference (`setDraft({ fromStep: "generate" })`) instead of having a model
 * retype it into a tool argument, which is where every copy drift came from.
 *
 * Only the latest run's outputs are kept: a new run replaces the store.
 */

let currentRunId = null;
const outputs = new Map();

export function recordStepOutput(runId, stepId, output) {
  if (!runId || !stepId) {
    return;
  }
  if (runId !== currentRunId) {
    currentRunId = runId;
    outputs.clear();
  }
  outputs.set(stepId, output);
}

/** The output of `stepId` in the latest run, or undefined. */
export function getStepOutput(stepId, runId) {
  if (runId && runId !== currentRunId) {
    return undefined;
  }
  return outputs.get(stepId);
}

export function getStepOutputRunId() {
  return currentRunId;
}

export function listStepOutputs() {
  return Array.from(outputs.keys());
}

export function clearStepOutputs() {
  currentRunId = null;
  outputs.clear();
}
